export const PRIVILEGED_USER_ROLES = ['super_user', 'administrator'] as const;

export function isSuperUserRole(role?: string | null): boolean {
  return role === 'super_user';
}

export function isAdministratorRole(role?: string | null): boolean {
  return role === 'administrator';
}

export function isPrivilegedUserRole(role?: string | null): boolean {
  return isSuperUserRole(role) || isAdministratorRole(role);
}

/** Privileged roles are never required to have a published schedule for clock-in. */
export function isScheduleValidationExemptRole(role?: string | null): boolean {
  return isPrivilegedUserRole(role);
}

export function canViewAdministratorUsers(viewerRole?: string | null): boolean {
  return viewerRole === 'super_user' || viewerRole === 'administrator';
}

export function canViewSuperUserAccounts(viewerRole?: string | null): boolean {
  return viewerRole === 'super_user';
}

export function canAssignUserRole(
  viewerRole: string | null | undefined,
  roleToAssign: string | null | undefined,
): boolean {
  if (isSuperUserRole(roleToAssign) && !canViewSuperUserAccounts(viewerRole)) {
    return false;
  }
  if (isAdministratorRole(roleToAssign) && !canViewAdministratorUsers(viewerRole)) {
    return false;
  }
  return true;
}

export function filterUsersVisibleToViewer<T extends { role: string }>(
  users: T[],
  viewerRole?: string | null,
): T[] {
  return users.filter((user) => {
    if (isSuperUserRole(user.role) && !canViewSuperUserAccounts(viewerRole)) {
      return false;
    }
    if (isAdministratorRole(user.role) && !canViewAdministratorUsers(viewerRole)) {
      return false;
    }
    return true;
  });
}
